import "./jquery-bootstrap";
import Vue from "vue/dist/vue.esm.js";
import "./lib/moment";
import Sortable from "sortablejs";

window.Vue = Vue;
window.Sortable = Sortable;
